import { render, staticRenderFns } from "./readTrems.vue?vue&type=template&id=7ff75ae9&scoped=true"
import script from "./readTrems.vue?vue&type=script&lang=js"
export * from "./readTrems.vue?vue&type=script&lang=js"
import style0 from "./readTrems.vue?vue&type=style&index=0&id=7ff75ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff75ae9",
  null
  
)

export default component.exports